import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Card,
  Upload,
  Button,
  Icon,
  Col,
  message,
} from 'antd';
import { Product } from "../../../models";
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import styles from './index.less';

const mapStateToProps = state => ({
  currentProduct: state.product.current,
});
class UploadForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      uploading: false,
    };
  }
  handleUpload = async () => {
    const { fileList } = this.state;
    // const formData = new FormData();
    // fileList.forEach((file, index) => {
    //   formData.append(`file${index}`, file);
    // });

    this.setState({
      uploading: true,
      fileList: this.state.fileList.map((entry) => {
        entry.status = 'uploading';
        return entry;
      }),
    });

    // let index = 0;

    let bulk = {};

    (fileList || []).forEach((f) => {
      let nameArray = f.name.split('.')[0].split('_');

      if (bulk[nameArray[0]]) {
        bulk[nameArray[0]] = [
          ...bulk[nameArray[0]],
          f,
        ];
      } else {
        bulk[nameArray[0]] = [f];
      }
    });

    for (const key in bulk || {}) {
      if (Object.prototype.hasOwnProperty.call(bulk, key)) {
        try {
          const formData = new FormData();

          bulk[key].forEach((entry, i) => {
            formData.append(`file${i}`, entry);
          });

          // const response = await fetch('/randomAPI', {
          const response = await fetch('/rest/store_product/upload_multi', {
            credentials: 'include',
            method: 'POST',
            body: formData,
          });

          await response.json();

          this.state.fileList.forEach((entry, i) => {
            bulk[key].forEach((iterator) => {
              if (entry.uid === iterator.uid) {
                let dummy = entry;
                dummy.status = 'done';

                this.setState({
                  fileList: [
                    ...this.state.fileList.slice(0, i),
                    dummy,
                    ...this.state.fileList.slice(i + 1),
                  ],
                });
              }
            });
          });
        } catch (e) {
          this.state.fileList.forEach((entry, i) => {
            bulk[key].forEach((iterator) => {
              if (entry.uid === iterator.uid) {
                let dummy = entry;
                dummy.status = 'done';

                this.setState({
                  fileList: [
                    ...this.state.fileList.slice(0, i),
                    dummy,
                    ...this.state.fileList.slice(i + 1),
                  ],
                });
              }
            });
          });
        }
      }
    }

    this.setState({
      uploading: false,
    });


    // for (const file of fileList || []) {
    //   try {
    //     const formData = new FormData();
    //     formData.append('file0', file);

    //     // const response = await fetch('/rest/store_product/upload_multi', {
    //     const response = await fetch('/randomAPI', {
    //       credentials: 'include',
    //       method: 'POST',
    //       body: formData,
    //     });

    //     await response.json();

    //     let bla = this.state.fileList[index];
    //     bla.status = 'done';

    //     this.setState({
    //       fileList: [
    //         ...this.state.fileList.slice(0, index),
    //         bla,
    //         ...this.state.fileList.slice(index + 1),
    //       ],
    //     });
    //   } catch (error) {
    //     let bla = this.state.fileList[index];
    //     bla.status = 'error';
    //     this.setState({
    //       fileList: [
    //         ...this.state.fileList.slice(0, index),
    //         bla,
    //         ...this.state.fileList.slice(index + 1),
    //       ],
    //     });
    //   } finally {
    //     index += 1;
    //   }
    // }
    message.success('Зураг амжилттай хуулагдлаа.');

    // if (fileList === 'asdddajk') {
    //   fetch('/rest/store_product/upload_multi', { // Your POST endpoint
    //     credentials: 'include',
    //     method: 'POST',
    //     body: formData, // This is your file object
    //   }).then(response => response.json()).then(() => {
    //     this.setState({
    //       fileList: [],
    //       uploading: false,
    //     });
    //     message.success('Зураг амжилттай хуулагдлаа.');
    //     this.props.history.push({ pathname: '/products' });
    //   }).catch(() => {
    //     this.setState({
    //       uploading: false,
    //     });
    //     message.error('Зураг хуулах үед алдаа гарлаа.');
    //   });
    // }
  }

  render() {
    const { uploading } = this.state;
    const props = {
      action: '//jsonplaceholder.typicode.com/posts/',
      multiple: true,
      accept: 'image/*',
      onRemove: (file) => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file],
        }));
        return false;
      },
      onChange: () => {
      },
      fileList: this.state.fileList,
    };
    const breadcrumb = (
      <div className={styles.pageTop}>
        <Breadcrumb className={styles.Topbread}>
          <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/products">Бараа</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Зураг хуулах </Breadcrumb.Item>
        </Breadcrumb>
      </div>);
    return (
      <PageHeaderLayout
        content={breadcrumb}
      >
        <Card bordered bodyStyle={{ display: 'flex' }}>
          <Col span={24} className={styles.uploadBox}>
            <Upload {...props}>
              <Button>
                <Icon type="upload" /> Зураг сонгох
              </Button>
            </Upload>
            <Button
              className={`upload-demo-start ${styles.uploadBtn}`}
              type="primary"
              onClick={this.handleUpload}
              disabled={this.state.fileList.length === 0}
              loading={uploading}
            >
              {uploading ? 'Илгээж байна...' : 'Илгээх' }
            </Button>
          </Col>
        </Card>
      </PageHeaderLayout>
    );
  }
}

UploadForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object,
  pictureUpload: PropTypes.func.isRequired,
};

UploadForm.defaultProps = {
  history: undefined,
};


export default connect(mapStateToProps, {
  formReset: Product.reset,
  pictureUpload: Product.upload,
})(UploadForm);



// WEBPACK FOOTER //
// ./src/containers/Products/Upload/index.js